import React from "react"
import {List} from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


const FooterWorkingHours = () => {
    return (
                <div>
                    <h3 className="footer-title">Working hours</h3>
                    <List>
                        <List.Item><AccessTimeIcon sx={{ fontSize: 16 }} /> Mon - Fri 09:00 AM - 09:00 PM</List.Item>
                        <List.Item><AccessTimeIcon sx={{ fontSize: 16 }} /> Sat 09:00 AM - 07:00 PM</List.Item>
                        <List.Item><AccessTimeIcon sx={{ fontSize: 16 }} /> Sun: Closed</List.Item>
                    </List>
                </div>
    );
  }
  
  export default FooterWorkingHours;